import Column from '@components/Column';
import Header from '@components/Header';
import Tooltip from '@components/Tooltip';
import type { TypeActivities } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import AppleSignInButton from './components/AppleSignInButton';
import KakaoSignInButton from './components/KakaoSignInButton';
import Logo from './components/Logo';
import PhoneSignInButton from './components/PhoneSignInButton';
import SignUpText from './components/SignUpText';
import useAuthFlow from './hooks/useAuthFlow';
import styles from './styles.module.scss';

interface Params {
    flows?: {
        activityName: keyof TypeActivities,
        activityParams: object,
    }[]
}

const SignInActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { flows } = params;
  useAuthFlow(flows);
  const lastLoginMethod = window.localStorage.getItem('lastLoginMethod');
  const tooltipTop = ((() => {
    switch (lastLoginMethod) {
      case 'APPLE': return -40;
      case 'KAKAO': return 24;
      default: return 88;
    }
  })());
  return (
        <AppScreen>
            <Column fullHeight>
                <Header title='' noShadow/>
                <Column fullWidth fullHeight align='center'
                        className={styles.container}
                        justify='space-between'>
                    <Logo/>
                    <Column fullWidth
                            className={styles.containers}
                            spacing={8}>
                        <AppleSignInButton />
                        <KakaoSignInButton />
                        <PhoneSignInButton/>
                        <SignUpText/>
                        {lastLoginMethod && (
                            <Tooltip visibleKey='signInMethod'
                                     shape='line'
                                     hideClose
                                     top={tooltipTop} >
                                최근 로그인한 계정
                            </Tooltip>
                        )}
                    </Column>
                </Column>
            </Column>
        </AppScreen>
  );
};

export default SignInActivity;
